/**
 * Notification related types and interfaces
 * Based on actual SignalR payload structure
 */

export enum NotificationUserType {
  Homeowner = 1,
  Contractor = 2,
}

export enum NotificationType {
  NewProposal = 1,
  ProposalAccepted = 2,
  ProposalRejected = 3,
  ProjectCompleted = 4,
  PaymentReceived = 5,
  MessageReceived = 6,
  ReviewReceived = 7,
  ReviewReminder = 8,
}

export enum NotificationChannel {
  None = 0,
  InApp = 1,
  Email = 2,
}

export interface SocketNotificationPayload {
  id: string;
  title: string;
  description: string;
  data: string; // JSON string containing ProjectId, ProposalId, etc.
  isRead: boolean;
  notificationCount: number;
  unreadCount?: number;
  unReadCount?: number;
  proposalId?: string;
  projectId?: string;
  type: string;
  notificationType?: string;
  userType: NotificationUserType;
  createdOn: string;
}

export interface NotificationData {
  ProjectId?: string;
  ProposalId?: string;
  ContractorId?: string;
  ProjectTitle?: string;
  ContractorName?: string;
  HomeownerId?: string;
  HomeownerName?: string;
  FinalAmount?: number;
}

export interface NotificationItem {
  id: string;
  title: string;
  description: string;
  notificationType: string;
  notificationDays: string;
  data: NotificationData;
  createdOn: string;
  isRead: boolean;
}

export interface GetNotificationsRequest {
  pageNumber: number;
  pageSize: number;
  query: string;
  filters: string;
  sorts: string;
}

export interface GetNotificationsResponse {
  data: {
    count: number;
    data: NotificationItem[];
  };
  message: string;
  meta: {
    api: {
      apiVersion: string;
      buildVersion: string;
    };
    pagination: {
      pageSize: number;
      currentPage: number;
      totalItems: number;
      totalPages: number;
    };
  };
}

export interface MessageNotificationItem {
  id: string;
  title: string;
  description: string;
  notificationType: string;
  notificationDays: string;
  data: NotificationData;
  proposalId?: string;
  projectId?: string;
  createdOn: string;
  isRead: boolean;
}
export interface GetMessageNotificationsResponse {
  data: {
    count: number;
    data: MessageNotificationItem[];
  };
  message: string;
  meta: {
    api: {
      apiVersion: string;
      buildVersion: string;
    };
    pagination: {
      pageSize: number;
      currentPage: number;
      totalItems: number;
      totalPages: number;
    };
  };
}

export interface NotificationPreference {
  notificationType: string;
  notificationDescription: string;
  channel: string;
}

export interface GetNotificationPreferenceResponse {
  data: {
    preferences: NotificationPreference[];
  };
  message: string;
  meta: {
    api: {
      apiVersion: string;
      buildVersion: string;
    };
  };
}

export interface UpdateNotificationPreferenceItem {
  notificationType: NotificationType;
  channel: NotificationChannel;
}

export interface UpdateNotificationPreferenceRequest {
  preferences: UpdateNotificationPreferenceItem[];
}

export interface UpdateNotificationPreferenceResponse {
  data: {
    message: string;
  };
  message: string;
  meta: {
    api: {
      apiVersion: string;
      buildVersion: string;
    };
  };
}

export interface MarkAllAsReadResponse {
  data: {
    message: string;
  };
  message: string;
  meta: {
    api: {
      apiVersion: string;
      buildVersion: string;
    };
  };
}

export interface MarkAsReadResponse {
  data: {
    message: string;
  };
  message: string;
  meta: {
    api: {
      apiVersion: string;
      buildVersion: string;
    };
  };
}
